import { createContext } from 'use-context-selector';

/**
 * Legacy bucketplace/ui에서 필요한 것들만 따로 옮겨두었습니다.
 * 새로만든 Sticky를 기획전에 적용할 수 있으면 제거하면 됩니다.
 */

// These values are needed to determine the 'accumulatedOffset' of the
// sibling states.

var StickyValueContext = createContext(null);
var StickyControlContext = createContext(null);

export { StickyControlContext, StickyValueContext };
//# sourceMappingURL=StickyContext.js.map
